import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { CheckIconComponent } from '@kuiper/icons';
import { ProfileDropdownSubItem } from '../../profile-dropdown.model';
import { AvatarComponent } from '../../../../../../ui-components/lib/avatar/avatar.component';

@Component({
  selector: 'lib-profile-dropdown-sub-menu-item',
  imports: [TranslocoPipe, CheckIconComponent, AvatarComponent],
  templateUrl: './profile-dropdown-sub-menu-item.component.html',
  styleUrl: './profile-dropdown-sub-menu-item.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ProfileDropdownSubMenuItemComponent {
  subItem = input.required<ProfileDropdownSubItem>();
  action = output<ProfileDropdownSubItem>();

  selectSubMenuItem(subItem: ProfileDropdownSubItem) {
    this.action.emit(subItem);
  }
}
